import { _, Store } from 'utils';

const MAX = 10;
const SEARCH = 'search';
const KEYWORD = 'keyword';

class Recommendations extends Store {

	constructor(store)
	{
		super();

		this.store = store;
	}

	getInitialState() {
		return {
			recommendations: [],
			loading: false,
			query: '',
			visible: false,
			active: 0,
			selected: null,
			type: SEARCH
		}
	}

	getSalaryRecommendations(state, suggestions) {
		var salary = /\d+/g;
		var matches = state.query.match(salary);

		if(matches) {
			if(matches.length == 2) {
				var a = matches[0];
				var b = matches[1];

				var min = Math.min(a, b);
				var max = Math.max(a, b);

				var desc = _('Placa od {min} do {max}', { min: min, max: max});
				return suggestions.concat([{ src: 'salary', description: desc }]);

			} else if(matches.length == 1) {

				var salary = matches[0];
				var dayDesc = _('Samo životopisi sa promjenom u zadnjih {days} dana', { days: salary});

				var zipDesc = 'Poštanski broj počinje sa {zip}';
				if(salary >= 10000) {
					zipDesc = 'Poštanski broj {zip}';
				}

				return suggestions.concat([
					{ sid: 'days', src: 'days', description: dayDesc, days: salary},
					{ sid: 'zip', src: 'zip', description: _(zipDesc, { zip: salary }), zip: salary },
					{sid: 'min', src: 'salary', description: _('Minimalna plaća {salary}', {salary})},
					{sid: 'max', src: 'salary', description: _('Maximalna plaća {salary}', {salary}) }
				]);
			}
		}
		return suggestions;
	}

	getRecommendations() {
		var state = this.getState();
		var query = state.query.toLowerCase();
		var keyword = { src: 'keyword', description: query };
		var suggestions = [keyword];

		suggestions = this.getSalaryRecommendations(state, suggestions);
		
		return suggestions.concat(state.recommendations.slice(0, MAX));
	}

	getQuery() {
		var state = this.getState();
		var { active } = state;

		if(active == 0) {
			return state.query;
		} else {
			var recommendations = this.getRecommendations();
			var selected = recommendations[active];
			return selected.description;
		}
	}

	onClearFilters(state) {
		state.query = '';
		state.type = SEARCH;
		state.selected = null;
	}

	onHideRecommendations(state) {
		state.visible = false;
	}

	onNextSuggestion(state) {
		if(state.visible) {
			var recommendations = this.getRecommendations();
			state.active = Math.min(state.active + 1, recommendations.length - 1, MAX);
			state.type = KEYWORD
			state.selected = null;

		} else {
			state.visible = true;
		}
	}

	onPreviousSuggestion(state) {
		if(state.visible) {
			state.active = Math.max(state.active - 1, 0);
			state.type = KEYWORD;
			state.selected = null;
		} else {
			state.visible = true;
		}
	}

	onBlur(state) {
		state.visible = false;
	}

	onSelectSuggestion(state, selection) {
		var selected = selection.item;

		if(!selected) {
			state.selected = this.getRecommendations()[state.active];
		} else {
			var index = this.getRecommendations().findIndex(function(item) {
				return selected.src == item.src && selected.sid == item.sid;
			});

			state.selected = selected;
			state.active = index;
		}

		state.type = SEARCH;
		state.query = '';
		state.visible = false;
		state.active = 0;
	}

	onQueryChanged(state, data) {
		state.query = data.query;
		state.visible = data.query !== '';
		state.selected = null;

		if(data.query === '') {
			state.type = SEARCH;
		} else {
			state.type = KEYWORD;
		}

		state.active = 0;
	}

	onLoadingChanged(state, data) {
		state.loading = data.loading;
	}

	onRecommendationsChanged(state, data) {
		var store = this.store;

		state.recommendations = data.recommendations.filter(function(item) {
			return store == 'any' || item.src == store;
		});

		state.selected = null;
	}

	onAddFilter(state) {
		state.query = '';
		state.selected = null;
		state.recommendations = [];
		state.type = SEARCH;
	}

	reduce(state, action) {
		var payload = action.getPayload();

		if(!payload.store || payload.store === this.store) {
			return super.reduce(state, action);
		} else {
			return state;
		}
	}
}

const store = new Recommendations('any');
export default store;

const JobStore = new Recommendations('job');
export { JobStore };

const AreaStore = new Recommendations('area');
export { AreaStore };




// WEBPACK FOOTER //
// ./src/modules/model/Recommendations.js